import { computeCaptionsForClip } from '@/App/remotion/libs/caption/caption';
import { DEFAULT_FONT_SIZE } from '@/App/remotion/libs/caption/styles';
import { CaptionLineConfig, CaptionStyle, CaptionStyles, Clip } from '@/domains/asset';

export const updateCaptionPositions = (newClip: Clip) => {
  const clipLayout = newClip.asset_metadata.layout;
  const useRemotionCaptions = clipLayout !== 'AUDIOGRAM';
  const showCaptions = !!newClip.asset_metadata.subtitle;
  if (
    newClip.asset_metadata.caption_positions === undefined &&
    newClip.asset_metadata.caption_styles?.placement === undefined &&
    showCaptions &&
    useRemotionCaptions
  ) {
    newClip.asset_metadata.caption_positions = {
      x: '2.5%',
      y: '82%',
      width: '95%',
      height: '18%'
    } as any;
  }
};

export const updateCaptions = (newClip: Clip) => {
  const { captions, excludes, duration } = computeCaptionsForClip(newClip);

  newClip.asset_metadata.captions = captions;
  newClip.asset_metadata.excludes = excludes;
  newClip.asset_metadata.duration = duration;
};

export const getDefaultCaptionStyles = (newClip: Clip): CaptionStyles => {
  return {
    scale: 1,
    font_size: DEFAULT_FONT_SIZE,
    caps: false,
    line_config: newClip.asset_metadata.caption_styles?.line_config || CaptionLineConfig.OneLine,
    animation: newClip.asset_metadata.caption_styles?.animation || CaptionStyle.Outline
  };
};
